module.exports = __webpack_public_path__ + "static/media/TY_dummies_23.a12b3ca3.jpg";